import { Configuration } from '../../../interfaces/Configuration';
import Store from '../../../interfaces/Store';
import { NotificationFactory } from '../../../utils/factories/notificationFactory';
import { addNotificationsReducer } from '../../notifications/notifications.reducers';
import { calculateProductDeltas } from './calculateProductDelta';

export const addRequiredArticleNotificationIfNeeded = (
  pastConfiguration: Configuration,
  store: Store,
): Store => {
  const pastRequiredArticles = pastConfiguration.getRequiredArticles();
  const requiredArticles = store.configuration.getRequiredArticles();

  const addedRequiredProducts = calculateProductDeltas(
    pastRequiredArticles,
    requiredArticles,
  ).filter((articleDelta) => articleDelta.delta > 0);

  if (addedRequiredProducts.length) {
    return addNotificationsReducer(store, [
      NotificationFactory.automaticallyAddedRequiredArticle(addedRequiredProducts),
    ]);
  }

  return store;
};
